// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Rect} from '../rect.js'
import {PDFLineLayout} from '../search-index/pdfline-layout.js'

export class PDFBoxLayout {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): PDFBoxLayout {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsPDFBoxLayout(bb: flatbuffers.ByteBuffer, obj?: PDFBoxLayout): PDFBoxLayout {
    return (obj || new PDFBoxLayout()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsPDFBoxLayout(bb: flatbuffers.ByteBuffer, obj?: PDFBoxLayout): PDFBoxLayout {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new PDFBoxLayout()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  frame(obj?: Rect): Rect | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Rect()).__init(this.bb_pos + offset, this.bb!) : null
  }

  lines(index: number, obj?: PDFLineLayout): PDFLineLayout | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset
      ? (obj || new PDFLineLayout()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!
        )
      : null
  }

  linesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  static startPDFBoxLayout(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addFrame(builder: flatbuffers.Builder, frameOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, frameOffset, 0)
  }

  static addLines(builder: flatbuffers.Builder, linesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, linesOffset, 0)
  }

  static createLinesVector(builder: flatbuffers.Builder, data: flatbuffers.Offset[]): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startLinesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static endPDFBoxLayout(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // frame
    builder.requiredField(offset, 6) // lines
    return offset
  }

  static createPDFBoxLayout(
    builder: flatbuffers.Builder,
    frameOffset: flatbuffers.Offset,
    linesOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    PDFBoxLayout.startPDFBoxLayout(builder)
    PDFBoxLayout.addFrame(builder, frameOffset)
    PDFBoxLayout.addLines(builder, linesOffset)
    return PDFBoxLayout.endPDFBoxLayout(builder)
  }
}
